export default __webpack_public_path__ + "71f922fd79edf89a33d4615049385856.svg";